
<div class="video-detail-layout">
  <div class="video-detail-form">
    <h4>{{ isNew ? 'New Video' : 'Edit Video' }}</h4>

    <form [formGroup]="videoForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label class="center-block">ID (Vimeo):</label>
        <input class="form-control" formControlName="id"
          [ngClass]="{ 'is-invalid': submitted && f.id.errors }" />
        @if (submitted && f.id.errors) {
          <div class="invalid-feedback">
            @if (f.id.errors.required) {
              <div>ID is required</div>
            }
          </div>
        }
      </div>

      <div class="form-group">
        <label class="center-block">Bunny ID:</label>
        <input class="form-control" formControlName="bunny_id"
          [ngClass]="{ 'is-invalid': submitted && f.bunny_id.errors }" />
        @if (submitted && f.bunny_id.errors) {
          <div class="invalid-feedback">
            @if (f.bunny_id.errors.required) {
              <div>Bunny ID is required</div>
            }
          </div>
        }
      </div>

      <div class="form-group">
        <label class="center-block">Title:</label>
        <input class="form-control" formControlName="title"
          [ngClass]="{ 'is-invalid': submitted && f.title.errors }" />
        @if (submitted && f.title.errors) {
          <div class="invalid-feedback">
            @if (f.title.errors.required) {
              <div>Title is required</div>
            }
          </div>
        }
      </div>

      <div class="form-group">
        <label class="center-block">Thumbnail:</label>
        <input class="form-control" formControlName="thumbnail" />
      </div>

      <div class="form-group">
        <label class="center-block">Duration (mm:ss):</label>
        <input class="form-control" formControlName="duration" placeholder="e.g. 2:13" />
      </div>

      @if (errorMessage) {
        <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
      }

      <div style="margin-bottom: 1em; text-align:right;">
        <button type="submit" class="save-btn"
          [class.state-success]="saveState === 'success'"
          [disabled]="saveState === 'saving' || saveState === 'success'">
          <i class="fa"
            [ngClass]="{'fa-save': saveState === 'idle', 'fa-spinner fa-spin': saveState === 'saving', 'fa-check': saveState === 'success'}"></i>
          {{ saveState === 'success' ? 'Saved' : 'Save' }}
        </button>
        <button type="button" (click)="onCancel()" style="margin-left: 10px;" [disabled]="saveState === 'saving'">Cancel</button>
        &nbsp;
      </div>
    </form>
  </div>

  <div class="video-detail-preview">
    @if (vimeoPreviewUrl) {
      <iframe class="preview-video vimeo-preview" [src]="vimeoPreviewUrl" frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
    }

    <video #videoEl class="preview-video" controls playsinline crossorigin="anonymous" [hidden]="!video?.bunny_id"></video>
    @if (!video?.bunny_id) {
      <div class="preview-placeholder">Enter a Bunny ID and save to preview the video here.</div>
    }
  </div>
</div>
